import Votacao from "../Votacao";

export default function Masculinos() {
  return <Votacao colecao="masculinos" titulo="Perfumes Masculinos" />;
}
